export default {"src":"/developer/_next/static/media/vk-cloud.efb29a47.svg","height":40,"width":41,"blurWidth":0,"blurHeight":0};